import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { formatApiErrorDetail } from "../lib/api";
import { ArrowLeft } from "@phosphor-icons/react";
import logoWhite from "../assets/logo-white.png";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="login-page" className="min-h-screen bg-primary text-primary-foreground flex items-center justify-center px-6">
      <div className="w-full max-w-md">
        <Link to="/" className="inline-flex items-center gap-2 text-primary-foreground/60 hover:text-primary-foreground transition-colors mb-10 text-sm">
          <ArrowLeft size={16} /> Torna al sito
        </Link>
        <div className="serif text-4xl font-light mb-2"><img src={logoWhite} alt="Cleansof" className="h-12 w-auto" /></div>
        <p className="text-primary-foreground/50 font-light mb-10">Area riservata · Gestione prenotazioni</p>

        <form onSubmit={submit} className="space-y-5" data-testid="login-form">
          <div>
            <label className="overline text-primary-foreground/50 block mb-2">Email</label>
            <input
              data-testid="login-email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="w-full bg-transparent border border-primary-foreground/25 rounded-xl px-4 py-3.5 font-light outline-none focus:border-secondary transition-colors"
              placeholder="admin@cleansof.it"
            />
          </div>
          <div>
            <label className="overline text-primary-foreground/50 block mb-2">Password</label>
            <input
              data-testid="login-password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="w-full bg-transparent border border-primary-foreground/25 rounded-xl px-4 py-3.5 font-light outline-none focus:border-secondary transition-colors"
              placeholder="••••••••"
            />
          </div>
          {error && <p data-testid="login-error" className="text-red-300 text-sm font-light">{error}</p>}
          <button
            data-testid="login-submit"
            type="submit"
            disabled={loading}
            className="w-full rounded-full bg-background text-primary py-4 font-medium hover:bg-secondary transition-colors active:scale-[0.98] disabled:opacity-60"
          >
            {loading ? "Accesso…" : "Accedi"}
          </button>
        </form>
      </div>
    </div>
  );
}
